<template>
	<main class="px-2 md:px-6 mb-12">
		<section v-if="campaign.length > 0">
			<div class="flex mb-6">
				<h4><strong>Campaign</strong></h4>
			</div>
			<campaign-slider :data="campaign"></campaign-slider>
		</section>
	</main>
</template>
<script>
	export default {
		components: {
			CampaignSlider: () => import('@/views/home/campaign/components/CampaignSlider.vue')
		},
		data: () => ({
			campaign: []
		}),
		props: ['user_id'],
		methods: {
			getCampaign() {
				this.$store.dispatch('campaign/getData', {
					mutation: 'SET_SAHABAT_CAMPAIGN',
					params: {
						user_id: this.user_id,
						status: 1,
						length: 10
					}
				})
				.then(campaign => {
					this.campaign = campaign;
				})
				.catch(e => {
					console.error(e);
					return false;
				});
			}
		},
		created() {
			this.getCampaign();
		}
	}
</script>